var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M2.6.45L9 6.84l6.4-6.4a1.53 1.53 0 1 1 2.15 2.17L11.16 9l6.4 6.4a1.53 1.53 0 1 1-2.17 2.15L9 11.16l-6.4 6.4a1.53 1.53 0 1 1-2.15-2.17L6.84 9 .44 2.6A1.53 1.53 0 1 1 2.61.45z"}})}
var staticRenderFns = []

export { render, staticRenderFns }